import { useEffect, useRef, useState } from "react";
import Select, { components } from "react-select";

import styles from "./styles.module.css";
import React from "react";
import { useFindOptionsEffect } from "./src/find-options-effect";
import { fontWeight, margin, minHeight, padding } from "@mui/system";

const groupStyles = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  background: "#D9D9D980",
  color: "var(--black-400)",
  fontWeight: "bold",
  textTransform: "capitalize",
};

const formatGroupLabel = (data) => (
  <div style={groupStyles}>
    <span>{data.label}</span>
  </div>
);

/**
 * Componente que utiliza lib Select2
 *
 * @param {onFocus} param0
 * @returns
 */
const SelectUnstyled = ({
  id,
  name,
  onFocus,
  onBlur,
  handleChange,
  style,
  handleFindOptions,
  noOptionsMessage,
  className,
  wl,
  key,
  handleMenuOpen,
  ...restProps
}) => {
  const [styleFocus, setStyleFocus] = useState({});
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState(restProps.options ?? []);
  const [searchValue, setSearchValue] = useState("");
  const [menuSize, setMenuSize] = useState({ width: 0, height: 0 });
  const uniqueId = id || `select-${Math.random().toString(36).substr(2, 9)}`;

  useFindOptionsEffect(
    searchValue,
    handleFindOptions,
    setOptions,
    setLoading,
   name
  );

  const handleInputChange = (inputValue, { action }) => {
    if (action === "input-change") {
      setSearchValue(inputValue);
    }
  };


  // const handleChangeOpcaoSelecionada   = (opcaoSelecionada) => {
  //   setValue(opcaoSelecionada?.label);
  //   handleChange(opcaoSelecionada);
  // }

  const customStyles = {
    control: (base) => ({
      ...base,
      border: "none",
      boxShadow: "none",
      backgroundColor: "transparent",
      minHeight: "20px",
    }),
    menu: (base) => ({
      ...base,
      with: "100%",
      top: "100%",
      left: 0,
      width: "100%",
      borderRadius: "0 0 8px 8px",
      border: "1px solid #ccc",
      borderTop: "none",
      zIndex: 10,
      // background: 'red',
      margin: "0",
    }),
    // indicatorSeparator: () => ({
    //   display: "none",
    // }),
    // indicatorsContainer: () => ({
    //   display: "none",
    // }),

    clearIndicator: (base) => ({
      ...base,
      // backgroundColor: wl?.cor_tema_3, // vermelho claro
      color: wl?.cor_tema_primaria ?? "#e0e0e0",
      padding: 0,
      // borderRadius: "4px",
      margin: 0,
      cursor: "pointer",
    }),
    group: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
    }),

    singleValue: (base) => ({
      ...base,
      fontSize: "16px",
      color: wl?.cor_tema_primaria ?? "gray",
      fontWeight: 700,
      margin: 0,
      padding: 0,
      heigth: "10px",
    }),
    indicatorSeparator: (base) => ({
      ...base,
      display: "none",
    }),
    dropdownIndicator: (base) => ({
      ...base,
      display: "none",
    }),
    loadingIndicator: (base) => ({
      ...base,
      color: wl?.cor_tema_3 ?? "#e0e0e0",
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
    }),
    input: (base) => ({
      ...base,
      padding: 0,
      margin: 0,
      color: wl?.cor_tema_primaria ?? "gray",
      fontWeight: 700,
      fontSize: "16px",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#929CA8",
      fontSize: "14px",
      margin: 0,
      padding: 0,
    }),

    groupHeading: (base) => ({
      //   display: 'none',   // remove o espaço do heading
      padding: 0,
      marginTop: 10,
      marginBottom: 5,
      //   height: 0,
    }),

    menuList: (base) => ({
      ...base,
      paddingTop: 0,
      paddingBottom: 0,
      margin: "20px",
      scrollbarWidth: "thin",
      scrollbarColor: "red #f1f1f1",
      maxHeight: 200,
    }),

    option: (base, state) => ({
      backgroundColor: state.isFocused
        ? wl?.cor_tema_3 ?? "#e0e0e0" // Cor dos itens selecionados ao passar do mouse
        : wl?.cor_tema_primaria
        ? "#fff"
        : "#fff",
      // color: state.isSelected ? "#000" ?? "#fff" : "#000",
      color: "#929CA8",
      marginBottom: "7px",
      padding: 0,
      cursor: "pointer",
    }),
    menuList: (base) => ({
      ...base,
      padding: 0,
      border: "1px solid #DDE1E7",
      borderRadius: "8px",
      maxHeight: 200,
    }),
  };

  const handleMenuActivation = () => {
    setTimeout(() => {
      const menu = document.querySelector(".custom-scroll__menu");
      if (menu) {
        const { height } = menu.getBoundingClientRect();
        if (height > 10) {
          handleMenuOpen(height, "open");
        }
      }
    }, 80);
  };


  const focus = (event) => {
    handleMenuActivation();
    if (onFocus) {
      onFocus(event);
    }
    setStyleFocus({
      border: "1px solid red !important",
      boxShadow: `0 0 0.5rem red !important`,
      outline: 0,
    });
  };

  const blur = (event) => {
    if (onBlur) {
      onBlur(event);
    }
    setStyleFocus({});
  };

  // const customComponents = {
  //   GroupHeading: () => null, // <- remove a tarja do estado
  // };

  const customLoadingMessage = () => "Carregando...";

  // Função para personalizar a mensagem quando não há opções
  const handleNoOptionsMessage = ({ inputValue }) =>
    inputValue ? "Não encontrado" : "Digite para buscar opções";

  // Custom Menu para adicionar data-select-id
  const CustomMenu = (props) => (
    <components.Menu
      {...props}
      innerProps={{
        ...props.innerProps,
        "data-select-id": uniqueId,
      }}
    />
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const menu = document.querySelector(`.custom-scroll__menu[data-select-id="${uniqueId}"]`);
      if (menu) {
        const { height } = menu.getBoundingClientRect();
        handleMenuOpen(height, "open");
      } else {
        handleMenuOpen(0, "close");
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => observer.disconnect();
  }, [handleMenuOpen, uniqueId]);

  return (
    <>
      <Select
        id={restProps.id}
        key={key}
        styles={{
          ...customStyles,
          ...styleFocus,
          ...style,
          menuList: (base) => ({
            ...base,
            maxHeight: 200,
            overflowY: "auto",
            maxHeight: 200,
            /* Aqui você injeta o estilo no próprio elemento */
            scrollbarWidth: "thin", // Firefox
            scrollbarColor: `${wl?.cor_tema_primaria ?? "gray"} #f1f1f1`, // Firefox
          }),
        }}
        className={`${styles.select} ${className}`}
        classNamePrefix="custom-scroll"
        components={{ ...restProps.components, Menu: CustomMenu }}
        options={options}
        onFocus={focus}
        onBlur={blur}
        required={restProps.required ?? false}
        isClearable={restProps.isClearable ?? true}
        isSearchable={restProps.isSearchable ?? true}
        isDisabled={restProps.isDisabled ?? false}
        isLoading={restProps.isLoading ?? loading}
        loadingMessage={customLoadingMessage}
        isRtl={restProps.isRtl ?? false}
        name={name ?? "select"}
        onInputChange={handleInputChange}
        onChange={handleChange}
        onClick={handleMenuActivation}
        formatGroupLabel={formatGroupLabel}
        noOptionsMessage={handleNoOptionsMessage}
        placeholder={
          restProps.placeholder ? restProps.placeholder : "Selecione uma opção"
        }
        defaultValue={
          restProps?.options?.filter(
            (option) => option?.label === restProps?.defaultValue
          ) ?? []
        }
        onKeyDown={() => {
          setTimeout(() => {
            const menu = document.querySelector(".custom-scroll__menu");

            if (menu) {
              const { height } = menu.getBoundingClientRect();

              // Garantir que a altura é válida
              if (height > 10) {
                handleMenuOpen(height, "open");
              } else {
                console.warn("⚠️ Altura muito baixa ou menu ainda animando.");
              }
            } else {
              console.warn("❌ Menu não encontrado no DOM.");
            }
          }, 10); // delay suficiente para o menu renderizar
        }}
        menuPosition="absolute"
        onMenuClose={() => {
          const menu = document.querySelector(".custom-scroll__menu");
          if (menu) {
            const { width, height } = menu.getBoundingClientRect();
            handleMenuOpen(height, "close");
          } else {
            // console.log("❌ On menu close : Menu não encontrado");
          }
        }}
        {...restProps}
      />
    </>
  );
};

export default SelectUnstyled;
